import { render, staticRenderFns } from "./CardsGrid.vue?vue&type=template&id=011ff6f1&scoped=true&"
import script from "./CardsGrid.vue?vue&type=script&lang=js&"
export * from "./CardsGrid.vue?vue&type=script&lang=js&"
import style0 from "./CardsGrid.vue?vue&type=style&index=0&id=011ff6f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ff6f1",
  null
  
)

export default component.exports